import React from "react";
import Truncate from 'react-truncate';
import {makeStyles} from "@mui/styles";
const useStyles = makeStyles(()=>{
    return {
        miniCardImage:{
            height:'80px',
            width: '80px',
            minWidth:"80px",
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#ffffff',
            overflow: 'hidden',
            '& img':{
                height: '100%',
                width: 'auto',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        },
        miniCardContent:{
            display: 'flex',
            flexWrap: 'nowrap',
            alignItems: 'center',
            padding: '8px'
        },
        miniCardTitle:{
            color: '#FFF',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '20.52px',
            letterSpacing: '0.103px'
        },
        miniCardPrice:{
            color: '#FFF',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: '500',
            lineHeight: '20.52px',
            letterSpacing: '0.103px',
            marginTop: '4px'
        },
        miniCardMetadata:{
            marginLeft: '16px',
            width: '100%'
        },
        miniCardButton:{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            border: 0,
            alignSelf: 'stretch',
            backgroundColor: '#2B2B2B',
            textAlign: 'center',
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: '500',
            lineHeight: '20px',
            letterSpacing: '1px',
            color: '#ffffff',
            textDecoration: 'none',
            padding: '8px 12px',
            cursor: 'pointer'
        },
        miniCardCTA:{
            paddingTop: '4px',
            width: '100%'
        }
    }
})
const MiniProduct = ({product, className, onClick, currencySymbol="$"}) => {
    const classes = useStyles();
    const price = product.price ?  currencySymbol + product.price : "";
    return <div className={className} data-testId={"products-swiper-mini"}>
        <div className={classes.miniCardContent}>
            <div className={classes.miniCardImage}>
                <img src={product.imageUrl} alt={product.title}/>
            </div>
            <div className={classes.miniCardMetadata}>
                <div className={classes.miniCardTitle}>
                    <Truncate lines={1} >
                        {product.title}
                    </Truncate>
                </div>
                <div className={classes.miniCardPrice} style={{minHeight: '14px'}}>
                    {/*{price}*/}
                </div>
                <div className={classes.miniCardCTA}>
                    <button  className={classes.miniCardButton} onClick={onClick}>
                        VIEW DETAILS
                    </button>
                </div>
            </div>

        </div>

    </div>
}
export default MiniProduct;
